import { Form, Input } from "antd";
import { getConfigAppPartType } from "../../utils";
import { AppPartType } from "../../AppForm/types";

interface IProps {
  isDisable?: boolean;
  preview?: boolean;
  item: AppPartType;
  parentItem?: AppPartType;
  style?: React.CSSProperties;
  isTable?: boolean;
  nameItem: string;
  styleColor?: React.CSSProperties;
}

const Calculated = (props: IProps) => {
  const { item, isDisable, nameItem, style, styleColor = {} } = props;
  const { isHiddenLabel, labelText } = getConfigAppPartType(item);

  return (
    <div style={style}>
      <Form.Item
        label={
          isHiddenLabel ? (
            <div></div>
          ) : (
            <div className="no-wrap-text" title={labelText}>
              {labelText}
            </div>
          )
        }
        shouldUpdate={(prevValues, curValues) =>
          prevValues?.[item?.id || ""] !== curValues?.[item?.id || ""]
        }
        name={nameItem}
      >
        <Input
          disabled
          className="app-calculated"
          placeholder="(自動入力)"
          style={styleColor}
        />
      </Form.Item>
    </div>
  );
};

export default Calculated;
